import type { SVGProps } from "react";

const SvgAirbankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#95c11f",
      }}
      d="M0 0h47v47H0z"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="M0 168.178c-1.663-10.26-1.531-17.872-1.531-22.853-18.534 26.816-40.708 26.816-49.975 26.816-24.16 0-35.073-6.925-41.709-13.23-9.921-9.937-14.563-23.49-14.563-36.745s4.642-37.729 35.397-51.969c20.561-9.292 50.008-9.292 66.233-9.292 0-10.905-.331-16.217-2.316-22.157-4.311-12.279-17.235-13.926-21.827-13.926-6.967 0-14.256 2.987-18.559 9.284-3.641 5.634-3.641 10.938-3.641 14.893h-47.997c.331-8.936 1.324-26.825 18.881-39.384 15.2-10.922 34.743-13.578 50.621-13.578 13.925 0 43.025 2.333 59.573 21.512 11.277 13.57 11.6 33.444 11.6 41.065l.331 67.193c0 14.223.289 28.454 3.26 42.371zm-60.103-51.655c0 11.261 7.612 23.846 23.821 23.846 8.928 0 16.217-4.311 20.867-9.598 8.597-10.599 9.267-23.498 9.267-41.386-31.458-2.648-53.955 7.264-53.955 27.138"
      transform="translate(6.348 17.03)scale(.03575)"
    />
    <path
      style={{
        fill: "#000000",
      }}
      d="M8.934 17.043h1.752v6H8.934z"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="m0-101.315-1.018-32.095h-46.003c.992 9.582 2.325 33.75 2.325 41.71V34.412H4.278v-82.417c0-20.859 2.987-46.36 52.639-41.726v-44.018C17.193-135.727 6.263-115.554 0-101.315"
      transform="translate(13.487 21.813)scale(.03575)"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="M0 157.157c-22.166 0-38.4-17.855-38.4-55.171 0-10.376 0-50.604 36.116-50.604 35.421 0 36.083 43.166 36.083 56.131 0 8.439 0 49.644-33.799 49.644M10.955 17.533c-8.622 0-30.78.678-47.344 22.513v-73.291h-49.007v220.28h47.344c1.009-10.268 1.356-17.483 1.663-22.771 15.24 26.138 41.684 26.088 50.306 26.088 33.444 0 69.849-21.868 69.849-84.411 0-56.313-32.095-88.408-72.811-88.408"
      transform="translate(21.153 22.362)scale(.03575)"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="M0 93.405c-4.634 5.296-11.907 9.573-20.851 9.573-16.233 0-23.845-12.568-23.845-23.854 0-19.841 22.513-29.762 53.963-27.114 0 17.856-.654 30.796-9.267 41.395m55.618-72.199c0-7.579-.356-27.47-11.6-41.056C27.47-39.062-1.655-41.354-15.547-41.354c-15.903 0-35.454 2.639-50.662 13.586C-83.766-15.2-84.743 2.672-85.065 11.6h47.981c0-3.955 0-9.25 3.64-14.885 4.319-6.28 11.584-9.259 18.534-9.259 4.65 0 17.558 1.638 21.86 13.892 1.977 5.958 2.317 11.253 2.317 22.175-16.217 0-45.689 0-66.184 9.267-30.804 14.223-35.438 38.755-35.438 51.977 0 13.255 4.634 26.841 14.537 36.753 6.636 6.305 17.575 13.239 41.726 13.239 9.276 0 31.458 0 50.001-26.816 0 4.972-.29 12.584 1.356 22.852h43.911c-2.987-13.925-3.244-28.14-3.244-42.387z"
      transform="translate(28.02 24.373)scale(.03575)"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="M0-108.911c-4.303-11.575-18.187-31.45-50.943-31.45-36.431 0-49.686 21.513-54.328 29.142l-1.299-25.145h-47.021c1.009 11.567 1.009 29.762 1.009 30.407V31.45h49.305v-96.517c0-12.907 3.004-21.181 5.95-25.476 5.303-7.967 14.884-12.924 25.492-12.924 12.593 0 20.213 6.934 23.821 14.232 2.689 5.287 2.689 11.261 2.689 18.186V31.45H4.65v-90.394c0-31.119-1.01-39.707-4.65-49.967"
      transform="translate(36.613 27.925)scale(.03575)"
    />
    <path
      d="M-240.166-190.411h379.002l-23.653 45.128-379.006.008z"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="matrix(-.0166 .03167 .03167 .0166 19.66 27.805)"
    />
    <path
      style={{
        fillRule: "nonzero",
        fill: "#000000",
      }}
      d="M0-114.728h-55.279l-50.405 69.518v-122.629h-48.652v220.95h48.652v-91.048l51.663 91.048h57.91l-60.905-95.325z"
      transform="translate(43.447 27.15)scale(.03575)"
    />
  </svg>
);
export default SvgAirbankLogo;
